import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import Spinner from "react-bootstrap/Spinner";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data } = useContext(Context);
  const [loader, setLoader] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetAllCountry = async () => {
    const response = await getData("/common/masters/all-vendors");
    if (response?.success) {
      setCountries(await Select2Data(response?.data, "vendor_id"));
    }
  };
  const GetAllStates = async (id) => {
    const response = await getData(`/common/masters/all-spotlight-type`);
    if (response?.success) {
      setStates(await Select2Data(response?.data, "spotlight_type_id"));
    }
  };

  useEffect(() => {
    GetAllCountry();
    GetAllStates();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    watch,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      setLoader(true);
      const DataToSend = new FormData();
      DataToSend.append("vendor_id", data?.vendor_id?.value);
      DataToSend.append("spotlight_type_id", data?.spotlight_type_id?.value);
      DataToSend.append("name", data?.name);
      // DataToSend.append("certificate", data?.certificate[0]);
      DataToSend.append("start_date", data?.start_date);
      DataToSend.append("end_date", data?.end_date);
      const response = await postData(`/admin/vendor/spotlight`, DataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setLoader(false);
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreview, setImagePreview] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
      clearErrors("image");
    }
  };
  const startDate = watch("start_date");
  const today = new Date().toISOString().split("T")[0];
  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Vendor Spotlight
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
            // className="stateclass"
          >
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Vendor</Form.Label>

                    <Controller
                      name="vendor_id" // name of the field
                      {...register("vendor_id", {
                        required: "Select Vendor",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.vendor_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={countries}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption.value); // Update Controller's value
                            GetAllStates(selectedOption.value);
                            setValue("vendor_id", selectedOption);
                            // setValue("state_id", null);
                          }}
                        />
                      )}
                    />

                    {errors.vendor_id && (
                      <span className="text-danger">
                        {errors.vendor_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Spotlight Type</Form.Label>

                    <Controller
                      name="spotlight_type_id" // name of the field
                      {...register("spotlight_type_id", {
                        required: "Select Spotlight Type",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.spotlight_type_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={states}
                        />
                      )}
                    />

                    {errors.spotlight_type_id && (
                      <span className="text-danger">
                        {errors.spotlight_type_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Name</Form.Label>

                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Name"
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          {...register("name", {
                            required: "Name is required",
                            validate: (value) =>
                              value.length <= 200 ||
                              "Data must be 200 characters or less",
                          })}
                        />
                      </InputGroup>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Start Date</Form.Label>

                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="date"
                          className={classNames({
                            "is-invalid": errors?.start_date,
                          })}
                          max={today}
                          {...register("start_date", {
                            required: "Start Date is required",
                            validate: (value) =>
                              value <= today ||
                              "Start Date cannot be a future date",
                          })}
                        />

                        {errors.start_date && (
                          <span className="text-danger">
                            {errors.start_date.message}
                          </span>
                        )}
                      </InputGroup>
                      {errors.start_date && (
                        <span className="text-danger">
                          {errors.start_date.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>End Date</Form.Label>

                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="date"
                          className={classNames({
                            "is-invalid": errors?.end_date,
                          })}
                          min={startDate || ""}
                          max={today}
                          {...register("end_date", {
                            required: "End Date is required",
                            validate: (value) => {
                              if (value > today) {
                                return "End Date cannot be a future date";
                              }
                              if (startDate && value < startDate) {
                                return "End Date must be greater than or equal to the Start Date";
                              }
                              return true;
                            },
                          })}
                        />

                        {errors.end_date && (
                          <span className="text-danger">
                            {errors.end_date.message}
                          </span>
                        )}
                      </InputGroup>
                      {errors.end_date && (
                        <span className="text-danger">
                          {errors.end_date.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              {/*    <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Certificate</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="file"
                        name="certificate"
                        placeholder="Certificate"
                        className={classNames("", {
                          "is-invalid": errors?.certificate,
                        })}
                        {...register("certificate", {
                          required: "Certificate is required",
                        })}
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                    </InputGroup>
                    {errors.certificate && (
                      <span className="text-danger">
                        {errors.certificate.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                {imagePreview && (
                  <div className="mt-2">
                    <img
                      src={imagePreview}
                      alt="Category Preview"
                      style={{ maxWidth: "100px" }}
                    />
                  </div>
                )}
              </Col>*/}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  {loader ? (
                    <>
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </>
                  ) : (
                    <>
                      <SaveButton
                        name={"save"}
                        handleSubmit={handleSubmit(onSubmit)}
                      />{" "}
                    </>
                  )}
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
